export default __webpack_public_path__ + "f72911a08c7f40065b7cd012c4e40058.png";